import { render } from "./SidebarDash.vue?vue&type=template&id=0a7f5814&scoped=true"
import script from "./SidebarDash.vue?vue&type=script&lang=js"
export * from "./SidebarDash.vue?vue&type=script&lang=js"

import "./SidebarDash.vue?vue&type=style&index=0&id=0a7f5814&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7f5814"]])

export default __exports__